import * as React from "react";
const SvgFiRrMapMarker = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-map-marker_svg__a)">
      <path
        fill="#062147"
        d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4m8.66 3.157-.719-.239A8.002 8.002 0 0 0 12.001 0a7.993 7.993 0 0 0-7.915 9.092 5.05 5.05 0 0 0-2.548 1.3A4.95 4.95 0 0 0 0 14v4.075a5.01 5.01 0 0 0 3.6 4.8l2.87.9c.482.15.984.226 1.49.225.457 0 .913-.063 1.354-.186l5.78-1.71a3 3 0 0 1 1.573 0l2.387.8A4 4 0 0 0 24 19.021v-5.149a5.015 5.015 0 0 0-3.34-4.715M7.758 3.762a5.987 5.987 0 0 1 8.484 0 6.037 6.037 0 0 1 .011 8.5L12.7 15.717a.99.99 0 0 1-1.389 0l-3.553-3.44a6.04 6.04 0 0 1 0-8.515M22 19.021a1.99 1.99 0 0 1-.764 1.572 1.97 1.97 0 0 1-1.626.395l-2.345-.788a5 5 0 0 0-2.717-.016l-5.784 1.708a3 3 0 0 1-1.694-.029l-2.894-.9A3.01 3.01 0 0 1 2 18.075V14a2.96 2.96 0 0 1 .92-2.163 3.03 3.03 0 0 1 1.67-.806A8 8 0 0 0 6.353 13.7l3.567 3.453a2.983 2.983 0 0 0 4.174 0l3.563-3.463a8 8 0 0 0 1.813-2.821l.537.178A3.01 3.01 0 0 1 22 13.872z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-map-marker_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMapMarker;
